import { FormBusinessRule } from 'src/shared/store/projects/types';

const normalizeColumnName = (value?: string): string => (value || '').trim().toLowerCase();

const resolveRuleTargetColumn = (rule: FormBusinessRule): string => {
  const fromRoot = normalizeColumnName(rule.targetColumn);
  if (fromRoot) {
    return fromRoot;
  }

  const configTarget = rule.config?.targetColumn;
  if (typeof configTarget === 'string') {
    return normalizeColumnName(configTarget);
  }
  return '';
};

export const getProtectedBusinessRuleColumns = (rules?: FormBusinessRule[] | null): Set<string> => {
  const protectedColumns = new Set<string>();
  (rules || []).forEach(rule => {
    if (rule?.enabled === false) {
      return;
    }

    const targetColumn = resolveRuleTargetColumn(rule);
    if (!targetColumn || targetColumn === 'id') {
      return;
    }
    protectedColumns.add(targetColumn);
  });
  return protectedColumns;
};

export const isProtectedBusinessRuleColumn = (
  columnName: string,
  protectedColumns?: Set<string> | null,
): boolean => {
  if (!protectedColumns || !protectedColumns.size) {
    return false;
  }
  return protectedColumns.has(normalizeColumnName(columnName));
};
